// extracted by mini-css-extract-plugin
export default {"workGroupArea":"accessLevelForm_workGroupArea__kgC3A","legendToms":"accessLevelForm_legendToms__0pAfP"};